import * as React from 'react';

import DiscussionsModal from 'bundles/discussions/components/DiscussionsModal';
import ModerationReasonForm from 'bundles/discussions/components/ModerationReasonForm';

import _t from 'i18n!nls/discussions';

export type Props = {
  handleCancel: () => void;
  handleSuccess: (reason: string, dontNotify: boolean) => void;
};

const EditWithModerationModal = ({ handleCancel, handleSuccess }: Props) => (
  <div className="rc-EditWithModerationModal">
    <DiscussionsModal handleClose={handleCancel} modalName={_t('Edit Post')}>
      <ModerationReasonForm handleCancel={handleCancel} handleSuccess={handleSuccess} />
    </DiscussionsModal>
  </div>
);

export default EditWithModerationModal;
